import { UseMutationOptions, useQueryClient } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import {
  SaveQualificationQuestionsMutation,
  SaveQualificationQuestionsMutationVariables,
} from "lib/generated/app-service-gql/graphql";
import { useGraphQlMutation } from "../../useGraphQlClient";

const SAVE_QUALIFICATION_QUESTIONS_MUTATION = graphql(`
  mutation saveQualificationQuestions($req: SaveQualificationQuestionsRequest!) {
    saveQualificationQuestions(SaveQualificationQuestionsRequest: $req) {
      questions {
        id
        title
        question
        order
        groupName
        teamId
        companyId
        autoQualify
      }
    }
  }
`);

export function useSaveQualificationQuestions(
  options?: UseMutationOptions<
    SaveQualificationQuestionsMutation,
    unknown,
    SaveQualificationQuestionsMutationVariables,
    unknown
  >,
) {
  const queryClient = useQueryClient();

  const { data, ...rest } = useGraphQlMutation(SAVE_QUALIFICATION_QUESTIONS_MUTATION, {
    ...options,
    onSuccess: async (data, vars, ctx) => {
      queryClient.setQueryData(["qualificationReportQuestions"], {
        qualificationReportQuestions: { ...data.saveQualificationQuestions },
      });
      options?.onSuccess?.(data, vars, ctx);
    },
  });

  return { data: data?.saveQualificationQuestions, ...rest };
}
